module.exports = __webpack_public_path__ + "img/83.7adac5f8.png";